<template>
  <v-card color="kbLight" style="position: relative">
    <v-card-text>
      <v-row>
        <!--<v-col class="pb-0" cols="12">
          <span class="kbDarkBlueText&#45;&#45;text d-block text-h6 mb-2">
            {{ $t('general.triggerName') }}
          </span>
          <v-text-field background-color="kbWhite"
                        color="kbDarkBlueText"
                        :label="$t('general.enterTriggerName')"
                        :rules="[rules.required]"
                        solo
                        validate-on-blur
                        v-model="trigger.name" />
        </v-col>-->

        <v-col class="pb-0" cols="12">
          <span class="kbDarkBlueText--text d-block text-h6 mb-2">
            {{ $t('general.pickTriggerType') }}
          </span>
          <v-select background-color="kbWhite"
                    color="kbDarkBlueText"
                    :items="triggerTypes"
                    item-text="name"
                    item-value="value"
                    :label="$t('general.pickTriggerType')"
                    :rules="[rules.required]"
                    solo
                    validate-on-blur
                    v-model="trigger.triggerType" />
        </v-col>

        <v-col cols="12" class="py-0" v-show="trigger.triggerType">
          <v-divider />
        </v-col>

        <v-col cols="12" class="pb-0" v-show="trigger.triggerType">
          <span class="kbDarkBlueText--text d-block text-h6 mb-2">
            {{ $t('general.triggerActions') }}
          </span>
          <v-row class="container flex-column mx-auto">
            <v-col class="pt-0"
                   cols="12"
                   v-for="(triggerAction, index) in trigger.actions"
                   :key="index">
              <TriggerAction :actionIndex="index"
                             :action-payload="triggerAction.payload"
                             :action-type="triggerAction.actionType"
                             :selectedRuleSequenceId="selectedRuleSequenceId"
                             @changeActionPayload="changeActionPayload($event, index)"
                             @changeActionType="changeActionType($event, index)"
                             @deleteAction="deleteAction(index)" />

              <v-row v-if="triggerAction.actionType === 'wait'">
                <v-col cols="12" class="pt-0">
                  <TriggerAction :action-payload="triggerAction.payload.waitPayload"
                                 :action-type="triggerAction.payload.waitActionType"
                                 :time-units="triggerAction.payload.timeUnits"
                                 :wait-for="triggerAction.payload.waitFor"
                                 is-action-nested
                                 :selectedRuleSequenceId="selectedRuleSequenceId"
                                 @changeActionPayload="changeActionPayload($event, index, true)"
                                 @changeActionType="changeActionType($event, index, true)"
                                 @changeWaitFor="changeWaitFor($event, index)"
                                 @onTimeUnitsChange="onTimeUnitsChange($event, index)" />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="pb-0 pt-4">
              <div>
                <v-btn color="mainButtons"
                       dark
                       small
                       @click="addAction()">
                  {{ $t('general.addAction') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon
               style="position: absolute; right: 10px; top: 10px"
               v-on="on"
               @click="deleteTrigger()">
          <v-icon color="kbRed">
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('general.deleteTrigger') }}</span>
    </v-tooltip>
  </v-card>
</template>

<script>
import rules from '@/libs/rules'
import TriggerAction from '@/pages/App/Sequences/Rules/dialogs/CreateEditRule/TriggerAction'
export default {
  components: { TriggerAction },
  computed: {
    triggerTypes () {
      return [
        { name: 'Email sent', value: 'onEmailSent' },
        { name: 'Email delivered', value: 'onEmailDelivered' },
        { name: 'Email rejected', value: 'onEmailRejected' },
        { name: 'Email deferral', value: 'onEmailDeferral' },
        { name: 'Email bounced', value: 'onEmailBounced' },
        { name: 'Email hard bounced', value: 'onEmailHardBounced' },
        { name: 'Email soft bounced', value: 'onEmailSoftBounced' },
        { name: 'Email opened', value: 'onEmailOpened' },
        { name: 'Email clicked', value: 'onEmailClicked' },
        { name: 'Email spam', value: 'onEmailSpam' },
        { name: 'Email unsubscribed', value: 'onEmailUnsub' },
        { name: 'Email black list', value: 'onEmailBlacklist' },
        { name: 'Email white list', value: 'onEmailWhitelist' },
        { name: 'Email unknown', value: 'onEmailUnknown' },
        { name: 'Task unknown', value: 'onTaskUnknown' },
        { name: 'Task bad number', value: 'onTaskBadNumber' },
        { name: 'Task busy call later', value: 'onTaskBusyCallLater' },
        { name: 'Task elevator pitch rejected', value: 'onTaskElevatorPitchRejected' },
        { name: 'Task false positive', value: 'onTaskFalsePositive' },
        { name: 'Task follow up required', value: 'onTaskFollowUpRequired' },
        { name: 'Task gatekeeper did not transfer', value: 'onTaskGatekeeperDidNotTransfer' },
        { name: 'Task gatekeeper transferred did not leave VM', value: 'onTaskGatekeeperTransferredDidNotLeaveVM' },
        { name: 'Task gatekeeper transferred left VM', value: 'onTaskGatekeeperTransferredLeftVM' },
        { name: 'Task hook rejected', value: 'onTaskHookRejected' },
        { name: 'Task left voice mail', value: 'onTaskLeftVoicemail' },
        { name: 'Task meeting scheduled', value: 'onTaskMeetingScheduled' },
        { name: 'Task objection already have a solution', value: 'onTaskObjectionAlreadyHaveASolution' },
        { name: 'Task objection asked to send info', value: 'onTaskObjectionAskedToSendInfo' },
        { name: 'Task objection not a priority', value: 'onTaskObjectionNotAPriority' },
        { name: 'Task unknown', value: 'onTaskObjectionOther' },
        { name: 'Task objection other', value: 'onTaskPersonLeftCompany' },
        { name: 'Task reach back out in x time', value: 'onTaskReachBackOutInXTime' },
        { name: 'Task wrong person gave referral', value: 'onTaskWrongPersonGaveReferral' },
        { name: 'Task wrong person no referral', value: 'onTaskWrongPersonNoReferral' },
        { name: 'Task wrong phone number', value: 'onTaskWrongPhoneNumber' }
      ]
    }
  },
  data () {
    return {
      rules
    }
  },
  methods: {
    addAction () {
      this.$emit('addAction')
    },
    changeActionPayload ({ key, value }, actionIndex, isActionNested = false) {
      if (isActionNested) {
        this.trigger.actions[actionIndex].payload.waitPayload[key] = value
      } else {
        this.trigger.actions[actionIndex].payload[key] = value
      }
    },
    changeActionType (actionType, actionIndex, isActionNested = false) {
      this.setActionPayload(actionType, actionIndex, isActionNested)
      if (isActionNested) {
        this.trigger.actions[actionIndex].payload.waitActionType = actionType
      } else {
        this.trigger.actions[actionIndex].actionType = actionType
      }
      this.$forceUpdate()
    },
    changeWaitFor (waitFor, actionIndex) {
      this.trigger.actions[actionIndex].payload.waitFor = waitFor
    },
    deleteAction (index) {
      this.$emit('deleteAction', index)
    },
    deleteTrigger () {
      this.$emit('deleteTrigger')
    },
    onTimeUnitsChange (timeUnits, actionIndex) {
      this.trigger.actions[actionIndex].payload.timeUnits = timeUnits
    },
    setActionPayload (actionType, actionIndex, isActionNested) {
      let payload = {}
      if (actionType === 'wait') {
        payload = {
          waitActionType: '',
          waitFor: 0,
          timeUnits: 'minutes',
          waitPayload: {}
        }
      } else if (actionType === 'changeSequence') {
        payload = {
          sequenceId: '',
          stepId: ''
        }
      } else if (actionType === 'task') {
        payload = {
          name: '',
          observation: '',
          after: 0,
          timeUnits: 'minutes'
        }
      }
      if (isActionNested) {
        this.trigger.actions[actionIndex].payload.waitPayload = payload
      } else {
        this.trigger.actions[actionIndex].payload = payload
      }
    }
  },
  props: {
    selectedRuleSequenceId: {
      type: String,
      default: ''
    },
    trigger: {
      type: Object,
      required: true
    }
  }
}
</script>
